const Title = ({
    text
}) => {
  const base = 'text-bodyMobile md:text-bodyDesktop text-umber font-chivoMono'

  return <span className={base}>{text}</span>
}

export default Title
